import React from 'react';
import { useUser, updateUser, useAuth } from 'api';
import { useRouteMatch, Redirect } from 'react-router-dom';
import { Loading, Title, Text, Button, Card } from 'ui';
import "./index.css";

export default function User() {
  
  const auth = useAuth();
  const {params:{ userId }} = useRouteMatch();
  const user = useUser(userId);
  
  if(!auth || !user) {
    return <Loading/>;
  }
  
  const isAdmin = auth.user.role === 'ADMIN';
  const isOwnUser = auth.user.id === userId;
  
  if(!isOwnUser && !isAdmin) {
    return <Redirect to="/"/>;
  }
  
  return (
    <div className="user">
      <section className="user-header">
        <Title block>{user.displayName}</Title>
        <Text block>{user.email}</Text>
      </section>
      
      {isOwnUser && (
        <section>
          <Button to="change-password" label="Change Password"/>
        </section>
      )}
      
      {isAdmin && 
        <section>
          <Title>Role</Title>
          <Card style={{padding:16}}>
            {["CONTRIBUTOR", "COMPANY_ADMIN", "ADMIN"].map(role => 
              <Button 
                key={role}
                onClick={() => updateUser(userId, {role})}
                label={role}
                backgroundColor={user.role === role ? "#ff4f00" : "transparent"}
                color={user.role === role ? "white" : "#424242"}
              />
            )}
          </Card>
        </section>
      }
      
      <Button to="/tos" label="Terms of Service" style={{padding:0}}/>
      
    </div>
  );
  
}